<template>
    <div class="bg-white p-1 lg:p-4 rounded">
        <apexcharts :options="areaChartOptions" :series="areaChartSeries"></apexcharts>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['title', 'type'],
    components: {
        apexcharts: VueApexCharts,
    },
    data: function() {
        return {
            areaChartOptions: {
                chart: {
                    type: this.type,
                    toolbar: {
                        show: false
                    },
                    parentHeightOffset: 0
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        distributed: false,
                        colors: {
                            ranges: [
                                {
                                    from: 0,
                                    to: 25,
                                    color: '#C7D2FE'
                                },
                                {
                                    from: 26,
                                    to: 50,
                                    color: '#818CF8'
                                },
                                {
                                    from: 51,
                                    to: 75,
                                    color: '#4F46E5'
                                },
                                {
                                    from: 76,
                                    to: 100,
                                    color: '#3730A3'
                                },
                            ]
                        },
                    }
                },
                // colors: ['#DC2626', '#D97706', '#000000', '#444444', '#DC2621', '#D97703', '#DC2326', '#D97706'],
                title: {
                    text: this.title,
                    style: {
                        fontSize: '17px'
                    }
                },
                fill: {
                    opacity: 0.7
                },
                labels: ['1 Mar', '2 Mar', '3 Mar', '4 Mar', '5 Mar', '6 Mar', '7 Mar', '8 Mar']
            },
            areaChartSeries: [{
                name: 'series-1',
                data: [
                    25, 
                    40, 
                    45, 
                    60, 
                    76, 
                    60, 
                    70, 
                    91
                ]
            }]
        }
    },
}
</script>

<style>

</style>